import styled, { css } from "styled-components";

import {
  getBorderRadius,
  getBorderWidth,
  getFontFamily,
  getFontSize,
  getFontWeight,
  getSemanticColor,
  getSpacing,
} from "@braze/beacon-styling";

export const DiffDisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing("sm")};
  padding: ${getSpacing("sm")} ${getSpacing("md")};
  background-color: ${getSemanticColor("neutral-background-default")};
  min-width: 0;
  overflow: hidden;
`;

export const DiffDisplayTitle = styled.span`
  font-size: ${getFontSize("body", "md")};
  font-weight: ${getFontWeight("bold")};
  color: ${getSemanticColor("neutral-text-default")};
  font-family: ${getFontFamily("code")};
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DiffEditorLabel = styled.span`
  display: inline-block;
  font-size: ${getFontSize("body", "sm")};
  font-weight: ${getFontWeight("bold")};
  color: ${getSemanticColor("neutral-text-default")};
  font-family: ${getFontFamily("code")};
  line-height: ${getSpacing("xl")};
`;

export const DiffTextContent = styled.div`
  padding: ${getSpacing("sm")} ${getSpacing("md")};
  background-color: ${getSemanticColor("neutral-background-weak")};
  border-radius: ${getBorderRadius("sm")};
  font-family: ${getFontFamily("code")};
  font-size: ${getFontSize("body", "md")};
  color: ${getSemanticColor("neutral-text-default")};
  white-space: pre-wrap;
  word-break: break-word;
  min-height: 1.1em;
  max-height: 140px;
  overflow-y: auto;
`;

export const DiffTextPlaceholder = styled.span`
  color: ${getSemanticColor("neutral-text-support-weak")};
`;

const diffValueSurface = css`
  padding: ${getSpacing("md")} ${getSpacing("lg")};
  background-color: ${getSemanticColor("neutral-background-weak")};
  border-radius: ${getBorderRadius("sm")};
  display: flex;
  align-items: center;
`;

export const DiffColorContent = styled.div`
  ${diffValueSurface};
  flex-direction: row;
  gap: ${getSpacing("sm")};
`;

export const DiffColorSwatch = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  background-color: ${({ color }): string => color};
  border-radius: ${getBorderRadius("tight")};
  border: ${getBorderWidth("thin")} solid ${getSemanticColor("neutral-border-decorative")};
`;

export const DiffColorHex = styled.span`
  font-family: ${getFontFamily("code")};
  font-size: ${getFontSize("body", "md")};
  color: ${getSemanticColor("neutral-text-default")};
`;

export const DiffImageContent = styled.div`
  ${diffValueSurface};
  justify-content: center;
`;

export const DiffImage = styled.img`
  max-width: 100%;
  max-height: 140px;
  object-fit: contain;
  border-radius: ${getBorderRadius("tight")};
  border: ${getBorderWidth("thin")} solid ${getSemanticColor("neutral-border-decorative")};
`;
